<div class="flex flex-col items-center justify-center min-h-screen">
  <span class="loader"></span>
  <h1 class="ml-4 mt-3  text-3xl font-extrabold leading-none tracking-tight  text-primary-100 md:text-3xl lg:text-3xl ">Loading ...</h1>
</div>
